import React, { Component } from 'react';
import request from 'request-promise-native';
import { withAuth } from '@cdk-prod/fortellis-auth-context';

import APIDirectory from './APIDirectory';
import { getAnonymousURL, getAuthHeader } from '../../../utils/service-utils';
import { types, INITIAL_STATE } from '../constants';
import reducer from './reducer';
import { withEntityContext } from '@cdk-prod/fortellis-entity-context';
import config from '../../../config/config';

const APIS_PAGE_SIZE = 100;

function withContainer(WrappedComponent) {
  return withEntityContext(
    class WithContainerComponent extends Component {
      constructor(props) {
        super(props);
        this.mounted = false;
        this.state = { ...INITIAL_STATE, isAuthenticated: false };
      }

      componentDidMount() {
        this.mounted = true;
        setTimeout(() => {
          this.getApis();
          this.getDomains();
        }, 300);
      }

      componentDidUpdate() {
        const {
          auth: { loginPending }
        } = this.props;
        if (!loginPending && !this.state.isAuthenticated) {
          this.setState({ isAuthenticated: true });
        }
      }

      /* STORE API FUNCTIONS */
      dispatch = action => {
        if (this.mounted) {
          this.setState(prevState => reducer(prevState, action));
        }
      };

      thunk = (options, actions, args = {}, callback) => {
        this.dispatch({ type: actions[0], args });
        request(options)
          .then(response => {
            this.dispatch({ type: actions[1], response, args });
            if (callback) {
              callback(undefined, response);
            }
          })
          .catch(error => {
            this.dispatch({ type: actions[2], error, args });
            if (callback) {
              callback(error);
            }
          });
      };
      /* END STORE API FUNCTIONS */

      getDomains = () => {
        let domainUrl = getAnonymousURL(
          this.props.auth,
          ` ${config.api.domainUrl}`
        );
        if (this.props.auth.isAuthenticated) {
          domainUrl += '/directory/groups';
        } else {
          domainUrl += '/v1/domains';
        }
        const options = {
          method: 'GET',
          url: `${domainUrl}`,
          headers: { ...getAuthHeader(this.props.auth) },
          json: true
        };

        return [];
      };

      getApis = () => {
        let apiGatewayURL = getAnonymousURL(
          this.props.auth,
          config.api.apiGatewayUrlV2
        );
        const options = {
          method: 'GET',
          url: `${apiGatewayURL}/directory`,
          headers: { ...getAuthHeader(this.props.auth) },
          json: true,
          qs: {
            view: 'combined',
            pageSize: APIS_PAGE_SIZE
          }
        };
        return [];
      };

      getApiPages = (totalPages, currentPage = 1) => {
        const apiGatewayURL = getAnonymousURL(
          this.props.auth,
          config.api.apiGatewayUrlV2
        );
        for (let currPage = currentPage; currPage <= totalPages; currPage++) {
          const options = {
            method: 'GET',
            url: `${apiGatewayURL}/directory`,
            headers: { ...getAuthHeader(this.props.auth) },
            json: true,
            qs: {
              view: 'combined',
              page: currPage,
              pageSize: APIS_PAGE_SIZE
            }
          };
          this.thunk(options, [
            types.GET_API_PAGES_REQUEST,
            types.GET_API_PAGES_RECEIVE,
            types.GET_API_PAGES_ERROR
          ]);
        }
      };

      render() {
        return (
          <React.Fragment>
            <WrappedComponent
              store={this.state}
              getApis={this.getApis}
              getDomains={this.getDomains}
              {...this.props}
            />
          </React.Fragment>
        );
      }
    }
  );
}

export default withAuth(withContainer(APIDirectory));
